import { Localize } from '@/i18n/Localize';
import { sharedPortuguese } from '@/i18n/shared';

import { Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTheme } from "@/components/ThemeProvider";
import { useLocale } from "@/i18n/LocaleProvider";
import { useLocalizedToast } from "@/i18n/shared";

export function ThemeToggle() {
  const { locale } = useLocale();
  const { toast } = useLocalizedToast();
  const { theme, toggleTheme } = useTheme();
  
  const handleToggle = () => {
    toggleTheme();
    toast({
      title: locale === 'pt-BR' ? `Modo ${theme === 'light' ? 'escuro' : 'claro'} ativado` : `Switched to ${theme === 'light' ? 'dark' : 'light'} mode`,
      duration: 1500,
    });
  };

  return <Localize messages={sharedPortuguese}>{(
    <Button
      variant="ghost"
      size="icon"
      className="rounded-full"
      onClick={handleToggle}
      aria-label={locale === 'pt-BR' ? `Ativar modo ${theme === 'light' ? 'escuro' : 'claro'}` : `Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
    >
      {theme === "light" ? (
        <Moon className="h-[1.2rem] w-[1.2rem]" />
      ) : (
        <Sun className="h-[1.2rem] w-[1.2rem]" />
      )}
      <span className="sr-only">
        {theme === "light" ? "Dark mode" : "Light mode"}
      </span>
    </Button>
  )}</Localize>;
}
